import { PartnerLink } from '@/components/shared/PartnerLinks/PartnerLink';
import { IComponentSharedPartnerLink } from '@/graphql/__generated__/global/types';

export type PartnerLinksProps = {
    partnerLinks: IComponentSharedPartnerLink[];
};

export const PartnerLinks = ({ partnerLinks }: PartnerLinksProps) => {
    if (partnerLinks.length === 0) {
        return null;
    }

    return (
        <div className="flex items-center gap-3 md:gap-6 justify-center flex-col md:flex-row">
            {partnerLinks.map((partnerLink) => (
                <PartnerLink partnerLink={partnerLink} key={partnerLink.id} />
            ))}
        </div>
    );
};
